import React from 'react';

function BlockF() {
  const otherExpensesData = [
    {
      slNo: 1,
      item: 'Work done by others on materials supplied by the industrial undertaking',
      expenditure: 0
    },
    {
      slNo: '2(1)',
      item: 'Repair & maintenance of building',
      expenditure: 0
    },
    {
      slNo: '2(2)',
      item: 'Repair & maintenance of Other Fixed Assets',
      expenditure: 0
    },
    {
      slNo: 3,
      item: 'Operating Expenses',
      expenditure: 0
    },
    {
      slNo: 4,
      item: 'Expenses on raw materials and other components for own construction',
      expenditure: 0
    },
    {
      slNo: 5,
      item: 'Insurance Charges',
      expenditure: 0
    },
    {
      slNo: 6,
      item: 'Rent Paid for P & M and Other Fixed Assets',
      expenditure: 0
    },
    {
      slNo: 7,
      item: 'Expenses on Research & Development (R&D)',
      expenditure: 0
    },
    {
      slNo: 8,
      item: 'Rent Paid for Buildings',
      expenditure: 0
    },
    {
      slNo: 9,
      item: 'Rent Paid for Land on lease or Royalties on mines, quarries and similar assets',
      expenditure: 0
    },
    {
      slNo: 10,
      item: 'Interest Paid',
      expenditure: 0
    },
    {
      slNo: 11,
      item: 'Purchase Value of Goods Sold in the same condition as purchased',
      expenditure: 0
    },
    {
      slNo: 12,
      item: 'Transport Inward',
      expenditure: 0
    },
    {
      slNo: 13,
      item: 'Transport Outward',
      expenditure: 0
    }
  ];

  const formatNumber = (num) => {
    return num.toLocaleString();
  };

  return (
    <>
      <style>
        {`
          .block-f-header {
            background-color: #e3f2fd;
            padding: 15px 20px;
            border-bottom: 2px solid #1976d2;
            margin-bottom: 20px;
          }
          .page-title {
            color: #1976d2;
            font-size: 24px;
            font-weight: bold;
            margin: 0;
          }
          .reference-numbers {
            color: #333;
            font-size: 14px;
            font-weight: 500;
            margin: 0;
          }
          .other-expenses-table {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
          }
          .table-header {
            background-color: #f8f9fa;
            border-bottom: 2px solid #1976d2;
          }
          .table th {
            background-color: #e3f2fd;
            color: #1976d2;
            font-weight: 600;
            font-size: 14px;
            text-align: center;
            vertical-align: middle;
            padding: 12px 8px;
            border: 1px solid #dee2e6;
          }
          .table td {
            font-size: 13px;
            text-align: center;
            vertical-align: middle;
            padding: 10px 8px;
            border: 1px solid #dee2e6;
          }
          .table td:first-child {
            text-align: center;
            font-weight: 600;
            width: 80px;
          }
          .table td:nth-child(2) {
            text-align: left;
            font-weight: 500;
            min-width: 400px;
          }
          .table td:nth-child(3) {
            text-align: right;
            font-weight: 500;
            width: 150px;
          }
          .sub-item {
            color: #666;
            font-size: 12px;
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        <div className="block-f-header">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1 className="page-title">F: OTHER EXPENSES</h1>
            </div>
            <div className="col-md-6 text-end">
              <p className="reference-numbers">DSL No : 404936</p>
              <p className="reference-numbers">PSL No : 31186</p>
            </div>
          </div>
        </div>

        {/* Other Expenses Table */}
        <div className="other-expenses-table">
          <div className="table-responsive">
            <table className="table table-bordered mb-0">
              <thead className="table-header">
                <tr>
                  <th>SI No (1)</th>
                  <th>Items (2)</th>
                  <th>Expenditure (in Rs.) (3)</th>
                </tr>
              </thead>
              <tbody>
                {otherExpensesData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.slNo}</td>
                    <td>{row.item}</td>
                    <td>{formatNumber(row.expenditure)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row mt-4">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button type="button" className="btn btn_orange mx-1">
              Print  
              <i className="fa fa-print ms-1"></i>
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Save
            </button>
            <button type="reset" className="btn btn_orange mx-1">
              Reset
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button type="button" className="btn btn_orange mx-1">
              Back 
              <i className="fa fa-angle-left ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockF; 